import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { EMAIL_VALIDATOR_KEY, ForgotSendMailRequest, REQUIRED_VALIDATOR_KEY } from '@pt/pt-models';
import { ValidatorGenerator } from '../../documents/utils/validator-generator';

@Component({
  selector: 'pt-forgot-password-send-mail',
  templateUrl: './forgot-password-send-mail.component.html'
})
export class ForgotPasswordSendMailComponent implements OnInit {
  @Input() emailLabel: string;
  @Input() domainLabel: string;
  @Input() confirmLabel: string;
  @Input() cancelLabel: string;
  @Input() domain: string;

  @Input() loading: boolean;

  @Output() clickConfirm = new EventEmitter<ForgotSendMailRequest>();
  @Output() clickCancel = new EventEmitter();

  formGroup: FormGroup;

  ngOnInit(): void {
    const required = ValidatorGenerator.generateWidgetValidator(REQUIRED_VALIDATOR_KEY);
    const email = ValidatorGenerator.generateWidgetValidator(EMAIL_VALIDATOR_KEY);

    const domainValidators = ValidatorGenerator.generateValidator([required]);
    const emailValidators = ValidatorGenerator.generateValidator([required, email]);

    this.formGroup = new FormGroup({
      domain: new FormControl(this.domain, domainValidators),
      email: new FormControl(null, emailValidators)
    });
  }

  confirm() {
    this.clickConfirm.emit(this.formGroup.getRawValue() as ForgotSendMailRequest);
  }

}
